// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__1L2JP","loader-spinner":"Spinner_loader-spinner__3j-fp","lds-spinner":"Spinner_lds-spinner__3Xmbx"};